// extracted by mini-css-extract-plugin
export var sliderContainer = "HeroSlider_sliderContainer__RCkNl";
export var dots = "HeroSlider_dots__OLVyn";
export var slideProgress = "HeroSlider_slide-progress__sJblf";
export var rotate = "HeroSlider_rotate__uOH4v";
export var dotty = "HeroSlider_dotty__kSzK7";